import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function Policy() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  useEffect(() => { api.get(`/legal/${slug}`).then(({data}) => setPage(data)).catch(()=>setPage(false)); }, [slug]);

  if (page === null) return <div className="container-x py-20 text-center">Loading…</div>;
  if (page === false) return <div className="container-x py-20 text-center"><div className="font-serif text-3xl">Page not found</div><Link to="/" className="mt-4 inline-block gold-text">Return home</Link></div>;

  return (
    <div className="container-x py-16 max-w-3xl" data-testid="policy-page">
      <SEO title={page.title} description={page.content.slice(0, 150)} />
      <h1 className="font-serif text-4xl md:text-5xl mb-8">{page.title}</h1>
      <div className="prose prose-sm text-muted-foreground whitespace-pre-line">{page.content}</div>
    </div>
  );
}
